import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Home.css';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const box = document.querySelector('.box-all-questions');
      const clickedInside = event.target.closest(".faq-item");
      if (!clickedInside) {
        setOpenId(null);
        if (box) box.style.display = "none";
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [openId, setOpenId] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const faqList = [
    {
      id: 1,
      pergunta: "Como funciona o desconto para quem indica?",
      resposta:
        "Cada matrícula confirmada por sua indicação gera R$ 500 de desconto (até 3 indicações). A partir da 4ª matrícula confirmada, o valor sobe para R$ 700 por indicação. O desconto é aplicado automaticamente sobre o saldo devedor total do seu curso, sendo diluído nas parcelas restantes."
    },
    {
      id: 2,
      pergunta: "Quando recebo meus benefícios?",
      resposta:
        "Após a matrícula do seu amigo indicado ser confirmada — com contrato assinado e primeira mensalidade paga. O desconto é então aplicado automaticamente na mensalidade seguinte, diluído nas parcelas restantes do seu curso."
    },
    {
      id: 3,
      pergunta: "Como acompanho o status das minhas indicações?",
      resposta:
        "Pela plataforma, onde você visualiza em tempo real o status de cada indicação."
    },
    {
      id: 4,
      pergunta: "Existe limite de pessoas que posso indicar?",
      resposta:
        "Você pode indicar quantas pessoas quiser — não há limite de indicações. Mas os descontos seguem estas regras: R$ 500 por matrícula confirmada (até 3 indicações); R$ 700 por matrícula confirmada a partir da 4ª indicação. Os descontos são acumulativos, mas não podem ultrapassar o saldo devedor das suas parcelas."
    },
    {
      id: 5,
      pergunta: "O desconto pode ser usado com outras promoções?",
      resposta:
        "Não. O desconto do programa “Amigo indica Amigo” não é cumulativo com outras promoções, bolsas ou campanhas de desconto vigentes. Ele é aplicado de forma exclusiva, conforme as regras do programa Amigo indica Amigo."
    },
    {
      id: 6,
      pergunta: "Posso indicar pessoas de outros estados?",
      resposta:
        "Sim. Você pode indicar pessoas de qualquer estado do Brasil e até mesmo de fora do país. O programa “Amigo indica Amigo” é válido para indicações realizadas em todo o território nacional e internacional, desde que os cursos e condições estejam de acordo com as regras vigentes do programa."
    }
  ];

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSignupClick = () => {
    navigate('/login');
  };

  const toggleFaq = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="home-container">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className='nav-logo'>
            <div className="logo">
              <img alt='' src='/images/home/Logo-Faculdade-2.svg' />
            </div>
            <div className='box-close-mobile'>
              {menuOpen ?
                <img alt='' src='/images/home/svg/header/close.svg' fill="currentColor" onClick={toggleMenu} /> :
                <img alt='' src='/images/home/svg/header/dehaze.svg' fill="currentColor" onClick={toggleMenu} />}
            </div>
            <nav className="nav">
              <a href="#como-funciona">Como funciona</a>
              {/* <a href="#beneficios">Benefícios</a> */}
              <a href="#participar">Quem pode participar</a>
              <a href="#duvidas">Dúvidas Frequentes</a>
            </nav>
          </div>
          <div className="header-buttons">
            {/* <button className="btn-signup" onClick={handleSignupClick}>
              Quero me inscrever
            </button> */}
            <button className="btn-login" onClick={handleLoginClick}>
              Login
            </button>
          </div>
          <nav className={`nav-mobile ${menuOpen ? "open" : ""}`}>
            <a href="#como-funciona" onClick={toggleMenu}>Como funciona</a>
            {/* <a href="#beneficios" onClick={toggleMenu}>Benefícios</a> */}
            <a href="#participar" onClick={toggleMenu}>Quem pode participar</a>
            <a href="#duvidas" onClick={toggleMenu}>Dúvidas Frequentes</a>
            {/* <button className="btn-signup" onClick={handleSignupClick}>
              Quero me inscrever
            </button> */}
            <button className="btn-login" onClick={handleLoginClick}>
              Login
            </button>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className='box-background'>
            <div className='box-hero-logo'>
              <div className="hero-logo">
                <img alt='' src='/images/home/Logo-Amigo-Indica-Amigo.svg' />
              </div>
              <div className="transforme-box">
                <div className='box-right'>
                  <p className="hero-slogan">
                    TRANSFORME SUA REDE EM OPORTUNIDADES REAIS
                  </p>
                  <button class="btn-saiba-mais" onClick={handleSignupClick}>SAIBA MAIS</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Como Funciona Section */}
      <section className="how-it-works" id="como-funciona">
        <div className="container">
          <div className="section-header">
            <h2 className="section-subtitle">COMO FUNCIONA</h2>
            <h3 className="section-title">
              Cada amigo que você indica para a UNIGUAÇU gera <span className="prevent-line-break"><span className="prevent-line-break">R$ 500</span></span> em descontos para você e garante uma condição especial para o seu amigo.
            </h3>
            <p className="section-description">
              Desconto garantido para ele, vantagem exclusiva para você. É simples, é oficial, é inteligente.
            </p>
            {/* <p className="section-description">
              Veja os quatro passos simples que conectam você aos seus amigos e aos benefícios que vocês merecem.
            </p> */}
          </div>
        </div>

        <div className="container steps-grid-container">
          <div className="steps-grid">
            <div className="steps-grid-row">
              <div className="step-card">
                <div className="step-number">#01</div>
                <h4>Nos conte sobre seu amigo</h4>
                <p>Preencha os dados básicos do amigo que você quer indicar para estudar na UNIGUAÇU</p>
              </div>
              <div className="step-card">
                <div className="step-number">#02</div>
                <h4>Envie o convite</h4>
                <p>Ele recebe um link personalizado via WhatsApp. Desconto já incluído, sem complicação.</p>
              </div>
            </div>
            <div className="steps-grid-row">
              <div className="step-card">
                <div className="step-number">#03</div>
                <h4>Acompanhe em tempo real</h4>
                <p>Seu amigo escolhe o curso ideal e garante o desconto! Você acompanha tudo em tempo real pela plataforma</p>
              </div>
              <div className="step-card">
                <div className="step-number">#04</div>
                <h4>Todos ganham desconto</h4>
                <p>Ele ganha desconto na primeira mensalidade e você recebe desconto na próxima!</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <button className="btn-cta" onClick={handleLoginClick}>
              <img alt='' src='/images/home/school.svg' />
              Sou aluno e quero indicar!
            </button>
          </div>
        </div>
      </section>

      {/* Program Rules Section */}
      <section className="program-rules" id="participar">
        <div className="container">
          <div className="section-header">
            <h2 className="section-subtitle">REGRAS DO PROGRAMA</h2>
            <h3 className="section-title">Como participar e aproveitar todos os benefícios</h3>
            <p className="section-description">
              O Amigo Indica Amigo segue uma dinâmica simples, mas com regras claras para garantir que todos aproveitem de forma justa e transparente. Veja como funciona para cada tipo de participante:
            </p>
          </div>

          <div className="rules-grid">
            <div className="rule-card current-students">
              <h4>Alunos Atuais</h4>
              <div className="rule-list">
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/person_book.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Quem pode participar:</strong>
                    <span>Alunos regularmente matriculados nos cursos de pós-graduação da UNIGUAÇU.</span>
                  </div>
                </div>
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/article.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Como funciona:</strong>
                    <span>O aluno acessa o sistema, informa os dados do amigo indicado e nossa equipe entra em contato para dar sequência no atendimento.</span>
                  </div>
                </div>
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/currency_exchange.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Descontos:</strong>
                    <span>Cada indicação confirmada garante <span className="prevent-line-break">R$ 500</span> de desconto diluído nas mensalidades restantes da sua pós. A partir da 4ª indicação confirmada, seu desconto sobe para <span className="prevent-line-break">R$ 700</span>.</span>
                  </div>
                </div>
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/gpp_maybe.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Limite:</strong>
                    <span>O desconto acumulado não pode ultrapassar o valor total da mensalidade.</span>
                  </div>
                </div>
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/beenhere.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Validação:</strong>
                    <span>A indicação só é validada se o novo aluno efetuar a matrícula a partir da indicação realizada pelo aluno.</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="rule-card new-students">
              <h4>Novos Alunos</h4>
              <div className="rule-list">
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/person_book.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Quem pode participar:</strong>
                    <span>Pessoas que ainda não estejam matriculadas em nenhum curso de pós-graduação da UNIGUAÇU.</span>
                  </div>
                </div>
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/article.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Como funciona:</strong>
                    <span>A indicação acontece diretamente entre você e seu amigo. Ele coleta seus dados e realiza o cadastro no sistema da faculdade. A partir disso, nossa equipe entra em contato com você para apresentar as informações da pós-graduação.</span>
                  </div>
                </div>
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/currency_exchange.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Descontos:</strong>
                    <span>Ao usar um código válido, você garante um desconto especial na primeira mensalidade.</span>
                  </div>
                </div>
                <div className="rule-item">
                  <div className="rule-icon">
                    <img alt='' src='/images/home/svg/regras/beenhere.svg' fill="currentColor" />
                  </div>
                  <div className="rule-content">
                    <strong>Validação:</strong>
                    <span>O desconto só é aplicado se você realizar a matrícula a partir do contato feito pela instituição referente à indicação do seu amigo.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <button className="btn-cta" onClick={handleSignupClick}>
              Quero participar do programa!
            </button>
          </div>
        </div>
      </section>

      {/* Have a Friend Section */}
      <section className="have-friend">
        <div className="friend-content">
          <div className="friend-left">
            <div className="friend-image">
              <div className='box-img-friend'>
                <img alt='' src="/images/home/image128.png" />
              </div>
              <div className="image-overlay">
                <div className='box-text-amigo'>
                  <h3>QUEM TEM UM AMIGO TEM TUDO!</h3>
                  <p>
                    Porque crescer sozinho é bom, mas crescer com os amigos é outro nível! Quando você indica alguém pra UNIGUAÇU, não está só compartilhando uma dica de faculdade, está montando aquela turma que vai fazer sua jornada acadêmica ser inesquecível!
                  </p>
                </div>
                <div className='box-logo-button'>
                  <button className="btn-friend" onClick={handleLoginClick}>
                    Clique aqui e indique!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq" id="duvidas">
        <div className="container">
          <h2 className="faq-title">Dúvidas Frequentes</h2>
          <div className="faq-list">
            <div>
              {faqList.slice(0, 3).map((item) => (
                <div
                  key={item.id}
                  className={`faq-item ${openId === item.id ? "open" : ""}`}
                  onClick={() => toggleFaq(item.id)}
                >
                  <div className="faq-question">
                    <span>{item.pergunta}</span>
                    <span className="faq-icon">{openId === item.id ? <img alt='' src="/images/home/svg/footer/x.svg" /> : "+"}</span>
                  </div>

                  <div className="faq-answer">
                    {item.resposta}
                  </div>
                </div>
              ))}
            </div>
            <div>
              {faqList.slice(3, 6).map((item) => (
                <div
                  key={item.id}
                  className={`faq-item ${openId === item.id ? "open" : ""}`}
                  onClick={() => toggleFaq(item.id)}
                >
                  <div className="faq-question">
                    <span>{item.pergunta}</span>
                    <span className="faq-icon">{openId === item.id ? <img alt='' src="/images/home/svg/footer/x.svg" /> : "+"}</span>
                  </div>

                  <div className="faq-answer">
                    {item.resposta}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          {/* <div className="footer-left">
            <a href="#codigo-conduta">Código de conduta</a>
            <a href="#termos">Termos de uso</a>
            <a href="#privacidade">Política de Privacidade</a>
          </div> */}
          <div className="footer-center">
            <div className="footer-logo">
              <img alt='' src='/images/home/Logo-Faculdade-Rodape.png' />
            </div>
          </div>
          <div className="footer-right">
            <div className="footer-uniguacu">
              <img alt='' src="/images/home/logo-uniguacu-branco.png" />
            </div>
            <div className="social-icons">
              <a target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/@uniguacubrasil" className="social-icon">
                <img alt='' src='/images/home/svg/footer/youtube.svg' fill="currentColor" />
              </a>
              <a target='_blank' rel="noopener noreferrer" href="https://www.instagram.com/uniguacubrasil" className="social-icon">
                <img alt='' src='/images/home/svg/footer/instagram.svg' fill="currentColor" />
              </a>
              <a target='_blank' rel="noopener noreferrer" href="https://api.whatsapp.com/send?phone=5545998100334" className="social-icon">
                <img alt='' src='/images/home/svg/footer/whatsapp.svg' fill="currentColor" />
              </a>
            </div>
          </div>
        </div>
        <div>
          <p className="footer-copyright">
            Copyright © 2025. Todos os direitos reservados. Faculdade Uniguaçu. CNPJ: 03.097.823/0001-75
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
